export default __webpack_public_path__ + "static/media/Shenzhen_Airlines-square-300x300.33879e67.png";